export default __webpack_public_path__ + "static/media/mdb.b060ef23.scss_";